export const animationDelay = {
    first: 0,
    second: 150,
    third: 300,
    fourth: 450,
};
